const resolve = ( val ) => {
  if ( typeof val === 'function' ) {
    return val()
  }
  return val
}

export default {
  resolve
}
